// extracted by css-extract-rspack-plugin
export default {"root":"src-wab-client-plasmic-plasmic_kit_dashboard-PlasmicNavSeparator-module__root-iLTRf5","roothideStarters":"src-wab-client-plasmic-plasmic_kit_dashboard-PlasmicNavSeparator-module__roothideStarters-drxlUw","rootnoPadding":"src-wab-client-plasmic-plasmic_kit_dashboard-PlasmicNavSeparator-module__rootnoPadding-LZvIIh","freeBox":"src-wab-client-plasmic-plasmic_kit_dashboard-PlasmicNavSeparator-module__freeBox-fc5kyb"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-wab-client-plasmic-plasmic_kit_dashboard-PlasmicNavSeparator-module__root-iLTRf5\",\"roothideStarters\":\"src-wab-client-plasmic-plasmic_kit_dashboard-PlasmicNavSeparator-module__roothideStarters-drxlUw\",\"rootnoPadding\":\"src-wab-client-plasmic-plasmic_kit_dashboard-PlasmicNavSeparator-module__rootnoPadding-LZvIIh\",\"freeBox\":\"src-wab-client-plasmic-plasmic_kit_dashboard-PlasmicNavSeparator-module__freeBox-fc5kyb\"}";
        // 1793541993453
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  